import React, { useEffect, useState } from 'react';
import { Card, Table, Spin } from 'antd';
import { Link } from 'react-router-dom';

import * as VThunk from '../../slices/vehicles/thunk';
import { useDispatch, useSelector } from 'react-redux';
import './LastestStatus.css'; // 引入自定义样式

const LastestStatus = () => {
  const dispatch = useDispatch();
  const { lastestStatusList } = useSelector(state => ({
    lastestStatusList: state.Vehicles.lastestStatusList || []
  }));

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 将数据转换为表格格式，并对数值进行处理
  const transformData = (data) => {
    return data.map(item => ({
      key: item.id,
      vehicle_id: item.vehicle_id,
      licensePlate: item.vehicle_name,
      sn: item.sn,
      windSpeed: item.backup_1 ? (parseInt(item.backup_1) / 1000).toFixed(3) : '0.000',
      moment: item.backup_2 ? (parseInt(item.backup_2) / 1000).toFixed(3) : '0.000',
      weight: item.backup_3 ? (parseInt(item.backup_3) / 1000).toFixed(3) : '0.000',
      boomLength: item.backup_4 ? (parseInt(item.backup_4) / 1000).toFixed(3) : '0.000',
      angle: item.backup_5 ? (parseInt(item.backup_5) / 1000).toFixed(3) : '0.000'
    }));
  };

  // 函数用于获取最新状态数据
  const fetchData = async () => {
    setLoading(true);
    try {
      await dispatch(VThunk.getLastestStatus());
    } finally {
      setLoading(false);
    }
  };

  // 初始加载数据
  useEffect(() => {
    fetchData();
  }, [dispatch]);

  // 设置定时器，每60秒刷新一次数据
  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 60000);

    // 清理定时器
    return () => clearInterval(interval);
  }, [dispatch]);

  // 监听数据变化，更新表格数据
  useEffect(() => {
    setTableData(transformData(lastestStatusList));
  }, [lastestStatusList]);

  // 定义表格列
  const columns = [
    {
      title: '车牌号',
      dataIndex: 'licensePlate',
      key: 'licensePlate',
      width: 200,
      align: 'center',
      render: (text, record) => <Link to={`/vehicles/${record.vehicle_id}?tab=location`}>{text}</Link>,
    },
    {
      title: '风速',
      dataIndex: 'windSpeed',
      key: 'windSpeed',
      width: 80,
      align: 'center',
    },
    {
      title: '力矩',
      dataIndex: 'moment',
      key: 'moment',
      width: 100,
      align: 'center',
    },
    {
      title: '重量',
      dataIndex: 'weight',
      key: 'weight',
      width: 80,
      align: 'center',
    },
    {
      title: '臂长',
      dataIndex: 'boomLength',
      key: 'boomLength',
      width: 80,
      align: 'center',
    },
    {
      title: '角度',
      dataIndex: 'angle',
      key: 'angle',
      width: 80,
      align: 'center',
    },
  ];

  return (
    <Card 
      title="车辆车身状态实时数据" 
      className="compact-card"
      style={{ height: '22em' }}
    >
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={tableData}
          size="small"
          pagination={{
            pageSize: 3,
            size: 'small'
          }}
          scroll={{ x: true }}
          className="compact-table"
        />
      </Spin>
    </Card>
  );
};

export default LastestStatus;